import type { ColumnDef, SortingState, Updater } from "@tanstack/react-table";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";

import type { TableProps } from "@/ui/table/table";
import { Table } from "@/ui/table/table";

type SinglePageTableProps<TData> = {
  className?: string;
  isLoadingData: boolean;
  data?: TData[];
  columns: ColumnDef<TData>[];
  sorting: SortingState;
  setSorting: (s: SortingState) => void;
} & Omit<TableProps<TData>, "table">;

export const SinglePageTable = <TData,>({
  className,
  columns,
  data,
  isLoadingData,
  setSorting,
  sorting,
  ...props
}: SinglePageTableProps<TData>) => {
  const handleSortChange = (updater: Updater<SortingState>) => {
    if (updater instanceof Function) {
      const params = updater(sorting);
      setSorting(params);
    }
  };

  const table = useReactTable({
    data: data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    state: { sorting },
    onSortingChange: handleSortChange,
  });

  return <Table className={className} isLoadingData={isLoadingData} table={table} {...props} />;
};
SinglePageTable.displayName = "SinglePageTable";
